import script from "./ScoreQueryPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreQueryPublic.vue?vue&type=script&setup=true&lang=js"

import "./ScoreQueryPublic.vue?vue&type=style&index=0&id=2b04a24e&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b04a24e"]])

export default __exports__